import { faChevronCircleLeft, faChevronCircleRight, faCircleNotch, faPlus, faWallet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import useWindowWidth from "components/reusable/useWindowWidth";
import Toolbar from "components/Toolbar";
import dayjs from "dayjs";
import { Button } from "flowbite-react";
import useToastContext from "hooks/useToastContext";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function EAlbaniaPayments() {
  const { t } = useTranslation();
  const notification = useToastContext();
  const navigate = useNavigate();
  const [pendingPayments, setPendingPayments] = useState(null);
  const [showAddNewEAlbaniaPayment, setShowAddNewEAlbaniaPayment] = useState(false);
  const pendingPaymentsScrollRef = useRef(null);
  const width = useWindowWidth();

  const [showNavLeft, setShowNavLeft] = useState(false);
  const [showNavRight, setShowNavRight] = useState(false);

  const [finishedPayments, setFinishedPayments] = useState(null);
  const [paymentActiveIndex, setPaymentActiveIndex] = useState(0);

  const handleScroll = () => {
    const el = pendingPaymentsScrollRef.current;
    if (!el) return;
    setShowNavLeft(el.scrollLeft > 0);
    setShowNavRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
    const idx = Math.round(el.scrollLeft / el.clientWidth);
    setPaymentActiveIndex(idx);
  };

  const getPendingPayments = async () => {
    try {
      const response = await apiGet(pathObj.pendingEAlbaniaTransactions);
      if (response.data.data.success) {
        setPendingPayments(response.data.data.lists);

        // setPendingPayments([
        //   {
        //     order_number: "1234567890",
        //     order_amount: 223232,
        //     service_name: "Tatime",
        //     currency: "ALL",
        //     order_date: new Date(),
        //     provider_name: "e-Albania",
        //   },
        //   {
        //     order_number: "2323",
        //     order_amount: 554646,
        //     service_name: "sdgsdfhdfhfgfghfghfg",
        //     currency: "ALL",
        //     order_date: new Date(),
        //     provider_name: "e-Aggghglbania",
        //   },
        //   {
        //     order_number: "242424",
        //     order_amount: 111,
        //     service_name: "Tatime",
        //     currency: "ALL",
        //     order_date: new Date(),
        //     provider_name: "e-Albafghfjfgjgfjnia",
        //   },
        //   {
        //     order_number: "24212512",
        //     order_amount: 44,
        //     service_name: "Tatim45654e",
        //     currency: "ALL",
        //     order_date: new Date(),
        //     provider_name: "e-Albania",
        //   },
        // ]);
      } else {
        setPendingPayments([]);
        notification.error(response.data.message);
      }
    } catch (err) {}
  };

  const getFinishedPayments = async () => {
    try {
      const response = await apiGet(pathObj.finishedEAlbaniaTransactions);
      if (response.data.data.success) {
        setFinishedPayments(response.data.data.lists);
      } else {
        setFinishedPayments([]);
        notification.error(response.data.message);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getPendingPayments();
    getFinishedPayments();
  }, []);

  useEffect(() => {
    const el = pendingPaymentsScrollRef.current;
    if (!el) return;
    scrollToPayment(0);
    el.removeEventListener("scroll", handleScroll);
    el.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => el.removeEventListener("scroll", handleScroll);
  }, [pendingPayments]);

  const scrollToPayment = async (i) => {
    if (!pendingPaymentsScrollRef.current) return;
    const el = pendingPaymentsScrollRef.current;
    el.scrollTo({
      left: el.clientWidth * i,
      behavior: "smooth",
    });
  };

  const { register, handleSubmit } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });
  const onNewPaymentSubmit = async (data) => {
    navigate("/payments/ealbania/pending-payment/" + data.order_number);
  };

  return (
    <>
      <Toolbar title={t("EALBANIA_PAYMENTS")} showBackBtn={true} />
      <div>
        <div className="flex w-full justify-center">
          <div className="container grid grid-cols-3 xl:grid-cols-4 gap-5 mx-4">
            <div className={`relative col-span-3 mx-4`}>
              {!pendingPayments && (
                <div className="flex w-full justify-center">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin h-[15rem]" />
                </div>
              )}
              {pendingPayments && pendingPayments.length === 0 && <div className="text-center text-lg mt-5">{t("NO_PENDING_EALBANIA_PAYMENTS")}</div>}
              {pendingPayments && (
                <div ref={pendingPaymentsScrollRef} className="rounded-2xl relative flex gap-2 overflow-x-auto no-scrollbar w-full snap-x snap-mandatory">
                  {(pendingPayments || []).map((it, idx) => (
                    <div key={it.order_number} className={`snap-center shrink-0 ${width < 767 ? "w-full" : "w-[25rem]"}`}>
                      <div className="bg-card mx-1 text-white p-[1rem] cursor-pointer">
                        <div className="font-medium text-lg">{it.service_name}</div>
                        <div className="font-medium text-yellow-600">
                          {it.currency} {it.order_amount}
                        </div>

                        <div className="font-medium grid grid-cols-2 w-full mt-4">
                          <div className="col-span-1">{t("PROVIDER")}</div>
                          <div className="col-span-1 text-gray-500 text-end">{it.provider_name}</div>

                          <div className="col-span-1">{t("ORDER_DATE")}</div>
                          <div className="col-span-1 text-gray-500 text-end">{dayjs(it.order_date).format("DD/MM/YYYY")}</div>

                          <div className="col-span-1">{t("ORDER_NUMBER")}</div>
                          <div className="col-span-1 text-gray-500 text-end">{it.order_number}</div>
                        </div>
                        <div className="flex justify-center mt-4">
                          <Button className="bg-primary mt-5" onClick={() => navigate(`/payments/ealbania/pending-payment/${it.order_number}`)}>
                            <FontAwesomeIcon icon={faWallet} className="text-white me-2" />
                            {t("PAY")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <FontAwesomeIcon
                icon={faChevronCircleRight}
                onClick={() => {
                  pendingPaymentsScrollRef.current.scrollBy({ left: 500, behavior: "smooth" });
                }}
                className={`cursor-pointer absolute right-[-0.5rem] -translate-y-1/2 card-icon top-1/2 hidden ${showNavRight ? "xl:block" : "xl:hidden"}`}
                size={"2xl"}
              />
              <FontAwesomeIcon
                icon={faChevronCircleLeft}
                onClick={() => {
                  pendingPaymentsScrollRef.current.scrollBy({ left: -500, behavior: "smooth" });
                }}
                className={`cursor-pointer absolute left-[-0.5rem] -translate-y-1/2 card-icon top-1/2 hidden ${showNavLeft ? "xl:block" : "xl:hidden"}`}
                size={"2xl"}
              />
              <div className="flex justify-center gap-2 mt-4 block xl:hidden">
                {Array.from({ length: (pendingPayments || []).length }).map((it, idx) => (
                  <div
                    key={idx}
                    onClick={() => scrollToPayment(idx)}
                    className={`transition-all rounded-full cursor-pointer 
                      ${idx === paymentActiveIndex ? "w-6 h-2 bg-primary" : "w-2 h-2 bg-gray-400"}
                    `}
                  />
                ))}
              </div>
            </div>
            <div className="col-span-3 xl:col-span-1 flex justify-center mt-5 xl:mt-0">
              <Button
                className="bg-card p-2 h-[4.5rem] w-full md:w-[20rem] gap-2 col-span-1 rounded-3xl"
                onClick={() => {
                  setShowAddNewEAlbaniaPayment(true);
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="card-icon" />
                <span className="text-lg font-medium">{t("NEW_PAYMENT")}</span>
              </Button>
            </div>
            <div className="col-span-3 mt-5">
              <div className="font-medium text-lg my-5">{t("FINISHED_PAYMENTS")}</div>
              {!finishedPayments && (
                <div className="flex w-full justify-center">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin h-[15rem]" />
                </div>
              )}
              {finishedPayments &&
                finishedPayments.map((it, idx) => (
                  <div key={it.order_number} className="bg-card p-0 mx-1 text-white mb-3">
                    <div className="flex justify-between items-center p-4">
                      <div className="flex justify-start items-center gap-2">
                        <img src="/images/E-Albania.svg" className="w-[4rem] h-[4rem]" alt="" />
                        <div className="flex flex-col">
                          <span className="font-medium">{it.service_name}</span>
                          <span className="text-sm">{it.order_number}</span>
                        </div>
                      </div>
                      <span className={`font-medium ${it.status === "completed" ? "text-green-700" : ""}`}>{t(it.status)}</span>
                    </div>
                    <div className="h-[3rem] bg-primary flex justify-between items-center rounded-b-2xl">
                      <div>
                        {it.invoice && (
                          <Link to={it.invoice} target="_blank" className="text-white font-medium ms-4">
                            {t("DOWNLOAD_INVOICE")}
                          </Link>
                        )}
                      </div>
                      <div className="font-medium px-5">ALL {it.amount}</div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {showAddNewEAlbaniaPayment && (
        <BottomSheet
          open={showAddNewEAlbaniaPayment}
          onClose={() => {
            setShowAddNewEAlbaniaPayment(false);
          }}
          title={t("NEW_EALBANIA_PAYMENT")}
        >
          <form onSubmit={handleSubmit(onNewPaymentSubmit)}>
            <div className="text-lg font-medium mb-2">{t("ORDER_NUMBER")}</div>
            <input
              type="text"
              id="order_number"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("order_number", {
                required: "",
              })}
            />

            <div className="w-full mt-5">
              <button className="btn btn_theme w-full text-white" type="submit">
                {t("PAY")}
              </button>
            </div>
          </form>
        </BottomSheet>
      )}
    </>
  );
}

export default EAlbaniaPayments;
